<script>
    export let options;

    let currentYear, addionalYears, years; //YearsAgo is used to know how many year options will the select show.
    currentYear = new Date().getFullYear();
    addionalYears = 1;
    years = [];

    for(var i = currentYear + addionalYears; i >= 2019; i--){
      years.push(i);
    }

</script>

<div class="col-md-1 mt-3 pr-0">
    <div class="dropdown" id="year-selector" >
        <button class="btn dropdown-toggle dropdown-date-selector" type="button" id="dropdownDate" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            {options.year}
        </button>
        <div class="dropdown-menu mw-100" aria-labelledby="dropdownDate">
          {#each years as year}
             <a on:click={ () => options.year = year}
             href="/{options.menu.url}/{(options.menu.url !='charts')? options.org.id: options.chartOrgs }{(options.subMenu)?'/'+options.subMenu:''}/{year}/{options.month}"
             class="dropdown-item">
              {year}
            </a>
          {/each}
        </div>
    </div>
</div>
